
















































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import AccountPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import { dateToDisplay } from '@/utils/dateTime'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class AccountAssetDetailDetail extends mixins(AccountPropertyDialog) {
  @Prop({ type: Object as () => AccountAsset }) readonly accountAsset!: AccountAsset

  dateToDisplay = dateToDisplay
  dollarFilter = dollarFilter

  get property () {
    return this.accountAsset.property || {}
  }

  get notes () {
    if (!this.accountAsset) return []
    return this.accountAsset.notes.split('\n')
  }
}
